import { create } from 'zustand';

type GlobalFiltersStore = {
  isGlobalFiltersDrawerOpen: boolean;
  openGlobalFiltersDrawer: () => void;
  closeGlobalFiltersDrawer: () => void;
};

const useTalentPageFiltersState = create<GlobalFiltersStore>()((set) => ({
  isGlobalFiltersDrawerOpen: false,
  openGlobalFiltersDrawer: () => set({ isGlobalFiltersDrawerOpen: true }),
  closeGlobalFiltersDrawer: () => set({ isGlobalFiltersDrawerOpen: false }),
}));

/**
 * current implementation just needs open/close state separate from Talent/Audience filter drawers.
 * Once we migrate away from split drawers we can move entire filter logic to this store if needed.
 */
export const useTalentPageFiltersStore = () => {
  return useTalentPageFiltersState();
};
